<template>
  <div id="empty" :style="{height: h}">
    <div class="wrap">
      <img :src="tipsImg" alt="">
      <p v-html="tips"></p>
    </div>
  </div>
</template>

<script>
  import EmptyImg from "@/assets/images/empty_tips.png";
  export default {
    name: "Empty",
    props: {
      tips: {
        type: String,
        default: "暂时没有数据~"
      },
      h: {
        type: String,
        default: "550px"
      }
    },
    data() {
      return {
        tipsImg: EmptyImg
      };
    },
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  #empty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    .wrap {
      text-align: center;
      img {
        margin: 0 0 15px 0;
      }
      p {
        font-size: 20px;
        color: $color_white;
        text-align:center;
      }
    }
  }
</style>